import Constants from '@/Constants';
import { SamlData } from '@/models/Salm';
import http from '@/services/HttpService';
import { AxiosError } from 'axios';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { samlFailure, samlSuccess } from './action';
import { SamlTypes } from './types';

export function* getUrlRedirectSaml(action: PayloadAction<SamlTypes.SAML_REQUEST, SamlData>) {
    try {
        const { data } = yield call(
            http.get,
            `${Constants.LOGIN_SAML_URI}${action.payload.applicationId}/${action.payload.orgId}?callback=${action.payload.callback}`,
        );

        yield put(samlSuccess(data));
    } catch (error) {
        yield put(samlFailure(error as AxiosError));
    }
}
